import './ContentLine.css';

function ContentLine() {
  return (
    <div className="content-line" />
  );
}

export default ContentLine;
